import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../components/Layout/Layout';
import styles from './Menu.module.css';

export const Menu: React.FC = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Dashboard',
      description: 'Statistiques et vue d\'ensemble',
      path: '/dashboard',
      icon: '📊',
    },
    {
      title: 'Commandes',
      description: 'Consulter et gérer les commandes',
      path: '/commandes',
      icon: '🛒',
    },
    {
      title: 'Produits',
      description: 'Gérer le catalogue de produits',
      path: '/produits',
      icon: '📦',
    },
    {
      title: 'Comptes',
      description: 'Gérer les comptes utilisateurs',
      path: '/comptes',
      icon: '👤',
    },
    {
      title: 'Réductions',
      description: 'Gérer les codes promo et réductions',
      path: '/reductions',
      icon: '🎟️',
    },
    {
      title: 'Import Facture',
      description: 'Importer un PDF de facture fournisseur',
      path: '/import-facture',
      icon: '📄',
    },
  ];

  return (
    <Layout>
      <div className={styles.menuContainer}>
        <h1 className={styles.title}>Menu Principal</h1>
        <p className={styles.subtitle}>Sélectionnez une section à gérer</p>

        <div className={styles.menuGrid}>
          {menuItems.map((item, index) => (
            <button
              key={index}
              className={styles.menuCard}
              onClick={() => navigate(item.path)}
            >
              <div className={styles.cardIcon}>{item.icon}</div>
              <h2 className={styles.cardTitle}>{item.title}</h2>
              <p className={styles.cardDescription}>{item.description}</p>
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
};